import {FilePost} from "../file/file-post";
import {HouseShareFile} from "../file/file";
import {EmailChangeConfirmType} from "../account/email-change-confirm-type";

export class UserPatch {
    email?: string;
    mobileNumber?: string;
    password?: string;
    forename?: string;
    surname?: string;
    image?: HouseShareFile | FilePost;
    updateImage?: boolean;
    acceptedCookieWarning?: boolean;
    dismissedAppNotice?: boolean;
    notificationsOffOverride?: boolean;
    darkMode?: boolean;
    privateProfile?: boolean;
    emailChangeConfirm?: EmailChangeConfirmType;
}
